import { StrictMode, useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from "@sentry/react"
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom"
import './index.css'
import App from './App.tsx'

// Initialize Sentry with React Router v6 integration
// Ensure we don't initialize twice (e.g. strict mode or HMR)
if (!Sentry.isInitialized()) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    enabled: import.meta.env.MODE === 'production',

    integrations: [
      // Official React Router v6 integration
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],

    tracesSampleRate: import.meta.env.MODE === 'production' ? 0.1 : 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    environment: import.meta.env.MODE,
    release: `orion-frontend@${import.meta.env.VITE_APP_VERSION || '1.0.0'}`,
  })
}
// Suppress benign Monaco Editor errors
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason?.message === 'operation is manually canceled' || event.reason?.type === 'cancelation') {
    event.preventDefault()
  }
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
